import { render, staticRenderFns } from "./VideoFullScreen.vue?vue&type=template&id=486de7cf&scoped=true&"
import script from "./VideoFullScreen.vue?vue&type=script&lang=js&"
export * from "./VideoFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoFullScreen.vue?vue&type=style&index=0&id=486de7cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486de7cf",
  null
  
)

export default component.exports